<template>
  <svg width="24" height="24" viewBox="0 0 24 24">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.7 2.28579C12.3111 1.90474 11.6889 1.90474 11.3001 2.28579L1.3001 12.0858C1.00992 12.3702 0.920644 12.8019 1.07423 13.178C1.22782 13.5542 1.59373 13.8 2.00003 13.8H6.71432V17C6.71432 17.5523 7.16203 18 7.71432 18H16.2857C16.838 18 17.2857 17.5523 17.2857 17V13.8H22C22.4063 13.8 22.7722 13.5542 22.9258 13.178C23.0794 12.8019 22.9901 12.3702 22.7 12.0858L12.7 2.28579ZM7.71432 11.8H4.44916L12 4.40014L19.5509 11.8H16.2857C15.7335 11.8 15.2857 12.2477 15.2857 12.8V16H8.71432V12.8C8.71432 12.2477 8.2666 11.8 7.71432 11.8Z"
    />
    <path
      d="M8.00003 20C7.44775 20 7.00003 20.4477 7.00003 21C7.00003 21.5523 7.44775 22 8.00003 22H16C16.5523 22 17 21.5523 17 21C17 20.4477 16.5523 20 16 20H8.00003Z"
    />
  </svg>
</template>
